import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import {
  LIST_VIDEO,
  SET_VIDEO,
  SET_ORDER,
  SET_SORT,
  SET_COUNT,
  SET_SKIP,
} from './type';

export const listVideo = createRoutine(LIST_VIDEO);

export const setVideo = createAction(SET_VIDEO);

export const setOrder = createAction(SET_ORDER);

export const setSort = createAction(SET_SORT);

export const setCount = createAction(SET_COUNT);

export const setSkip = createAction(SET_SKIP);
